export default "__VITE_ASSET__DZKsne0j__"